module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/2-9c9ba456c93a26a49ad99edc59f2acfa.svg";